<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" epub:type="dedication" id="dedication" role="doc-dedication">
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">Dedicated To</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">the US Astronauts</p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>and those who help them fly</i></p>
</div>
</div>
<hr class="implicit-break"/>
<p class="first first-in-chapter first-full-width dedication-content"><i>Up from Earth’s Centre through the Seventh Gate</i></p>
<p class="subsq dedication-content"><i>I rose, and on the Throne of Saturn sate,</i></p>
<p class="subsq dedication-content"><i>And many Knots unravel’d by the Road;</i></p>
<p class="subsq dedication-content"><i>But not the Knot of Human Death and Fate.</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right dedication-content">—The Rubaiyat of Omar Khayyám</p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?47e4ca84